import L from 'leaflet';

export default class Map {
    constructor() {
        this.coordonates = [43.46938705444336, -1.5445691347122192];

        const map = document.querySelector('footer .map');
        if (map) {
        	this.initMap(map);
        }
    }

    initMap(elt) {
        let map = L.map(elt, {
            center: this.coordonates,
            zoom: 13,
            zoomControl: false
        });

        L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png').addTo(map);

        const myIcon = L.icon({
            iconUrl: '/app/themes/laloge/assets/img/marker.svg',
            iconSize: [20, 26]
        });

        L.marker(this.coordonates, {icon: myIcon}).addTo(map);
	}
}